import React from 'react';
import { Target, TrendingUp } from 'lucide-react';

const About = ({ data }) => {
  return (
    <section id="about" className="section-container">
      <div className="content-wrapper">
        <div className="section-header">
          <h2 className="section-title">Transforming data into strategic impact</h2>
        </div>

        <div className="about-grid">
          <div className="about-main">
            <div className="about-card">
              <p className="about-text">{data.summary}</p>
              <p className="about-text mt-6">{data.passion}</p>
            </div>
          </div>

          <div className="about-highlights">
            <div className="highlight-card">
              <div className="highlight-icon">
                <Target size={24} />
              </div>
              <h3 className="highlight-title">Mission</h3>
              <p className="highlight-text">
                Building scalable AI, data science and analytics solutions that turn operational complexity into measurable business outcomes.
              </p>
            </div>

            <div className="highlight-card">
              <div className="highlight-icon">
                <TrendingUp size={24} />
              </div>
              <h3 className="highlight-title">Expertise</h3>
              <p className="highlight-text">
                Generative AI, machine learning, predictive modelling, data platforms, analytics transformation and decision intelligence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
